// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserUserImportPatients_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 7C8.10457 7 9 6.10457 9 5 9 3.89543 8.10457 3 7 3 5.89543 3 5 3.89543 5 5 5 6.10457 5.89543 7 7 7ZM7 9C9.20914 9 11 7.20914 11 5 11 2.79086 9.20914 1 7 1 4.79086 1 3 2.79086 3 5 3 7.20914 4.79086 9 7 9ZM8 10.083C7.67479 10.0284 7.34071 10 7 10 3.68673 10 1.0007 12.6856 1 15.9987H3C3.0007 13.7902 4.79129 12 7 12 7.3453 12 7.68038 12.0438 8 12.126V10.083ZM11 12V9H13V12H15L12 16 9 12H11Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 6C18 9.31371 15.3137 12 12 12C8.68629 12 6 9.31371 6 6C6 2.68629 8.68629 0 12 0C15.3137 0 18 2.68629 18 6ZM16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z" class="svg-bg"/>
  <path d="M12 16C12.6906 16 13.3608 16.0875 14 16.252V14.2C13.3538 14.0689 12.6849 14 12 14 6.47715 14 2 18.4772 2 24H4C4 19.5817 7.58172 16 12 16ZM17 18V13H19V18H22L18 24 14 18H17Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserUserImportPatients is a generated icon component.
 */
let IconUserUserImportPatients = IconUserUserImportPatients_1 = class IconUserUserImportPatients extends IconBaseElement {
    render() {
        return html `${IconUserUserImportPatients_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserUserImportPatients.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserUserImportPatients = IconUserUserImportPatients_1 = __decorate([
    customElement('zui-icon-user-user-import-patients')
], IconUserUserImportPatients);
export { IconUserUserImportPatients };
